export const environment = {
  production: true,
  develop: false,
  apiUrl: 'https://www.ambulanzeusate.it/api/'
};
